import React, { useState } from "react";
import "../styles/LoginPage.css";

const LoginPage = () => {
  const [uniqueCode, setUniqueCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!uniqueCode.trim()) {
      alert("Please enter your unique code");
      return;
    }
    console.log("Unique Code:", uniqueCode);
    // API call goes here
  };

  return (
    <div className="signin-wrapper">
      <div className="signin-card">
        <h2 className="title">Welcome Back</h2>
        <p className="subtitle">
          Sign in to continue your Bhandhan Sutra journey
        </p>

        <form onSubmit={handleSubmit}>
          <label>Unique Code</label>
          <input
            type="text"
            placeholder="Enter your unique code"
            value={uniqueCode}
            onChange={(e) => setUniqueCode(e.target.value)}
          />

          <button type="submit" className="signin-btn">
            Sign In
          </button>
        </form>

        <div className="divider">
          <span>OR</span>
        </div>

        <p className="signup-text">
          New to Bhandhan Sutra?
        </p>

        <button
          className="signup-btn"
          onClick={() => window.location.href = "/Matrimonial-register"}
        >
          Create Your Profile
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
